import { render, staticRenderFns } from "./factoryGoldLabel.vue?vue&type=template&id=6e2554b6&scoped=true"
import script from "./factoryGoldLabel.vue?vue&type=script&lang=js"
export * from "./factoryGoldLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2554b6",
  null
  
)

export default component.exports